import { useCallback, useEffect, useRef, useState } from 'react';
import { getApiErrorMessage } from '@/Services/api';
import sectionApi from '@/Services/sectionApi';

const useSectionData = <T>(endpoint: string, initialData: T, fallbackError: string, enabled = true) => {
    const [data, setData] = useState<T>(initialData);
    const [loading, setLoading] = useState(Boolean(enabled));
    const [error, setError] = useState('');
    const fetchedRef = useRef(false);

    const reload = useCallback(async () => {
        if (!enabled) return;

        setLoading(true);
        setError('');
        try {
            const payload = await sectionApi.getSection(endpoint);
            setData(payload as T);
        } catch (err) {
            setError(getApiErrorMessage(err, fallbackError));
        } finally {
            setLoading(false);
        }
    }, [enabled, endpoint, fallbackError]);

    useEffect(() => {
        if (fetchedRef.current) return;
        fetchedRef.current = true;
        reload();
    }, [reload]);

    return { data, loading, error, reload };
};

export default useSectionData;
